import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

export const IssueInProgressIcon: Icon = props => {
  return (
    <CustomIcon {...props}>
      <path
        fillRule="evenodd"
        d="M6.75.098a8 8 0 0 1 2.502 0 .75.75 0 0 1-.233 1.482 6.6 6.6 0 0 0-2.036 0A.75.75 0 1 1 6.75.098M4.346 1.694A.75.75 0 0 1 4.18 2.74a6.5 6.5 0 0 0-1.44 1.44.75.75 0 0 1-1.212-.883 8 8 0 0 1 1.769-1.77.75.75 0 0 1 1.048.166m7.31 0a.75.75 0 0 1 1.048-.165 8 8 0 0 1 1.77 1.769.75.75 0 1 1-1.214.883 6.5 6.5 0 0 0-1.44-1.44.75.75 0 0 1-.164-1.047M.956 6.126a.75.75 0 0 1 .624.857 6.6 6.6 0 0 0 0 2.036.75.75 0 1 1-1.482.233 8 8 0 0 1 0-2.502.75.75 0 0 1 .858-.624m14.09 0a.75.75 0 0 1 .858.624c.13.829.13 1.673 0 2.502a.75.75 0 1 1-1.482-.233 6.6 6.6 0 0 0 0-2.036.75.75 0 0 1 .624-.857m-13.352 5.53a.75.75 0 0 1 1.048.165 6.5 6.5 0 0 0 1.439 1.44.75.75 0 0 1-.883 1.212 8 8 0 0 1-1.77-1.77.75.75 0 0 1 .166-1.047m12.614 0a.75.75 0 0 1 .165 1.048 8 8 0 0 1-1.77 1.77.75.75 0 1 1-.882-1.214 6.5 6.5 0 0 0 1.44-1.44.75.75 0 0 1 1.047-.164m-8.182 3.39a.75.75 0 0 1 .857-.624 6.6 6.6 0 0 0 2.036 0 .752.752 0 0 1 .845.917.75.75 0 0 1-.612.565c-.83.13-1.673.13-2.502 0a.75.75 0 0 1-.624-.858"
        clipRule="evenodd"
      />
      <path d="M9.06 9.06a1.5 1.5 0 1 1-2.12-2.12 1.5 1.5 0 0 1 2.12 2.12" />
      <path d="M8 0a8 8 0 0 1 0 16v-1.5a6.5 6.5 0 1 0 0-13z" />
    </CustomIcon>
  )
}
